import React from 'react'
import Text from '../Text/Text'

import classNames from 'classnames'
import * as styles from './sectionWithGrid.module.scss'

import Section from '../Section'
import Swiper from '../Swiper'

export default function SectionWithGrid({
  hat,
  hatAs = 'h4',
  title,
  titleAs = 'h3',
  subtitleAs = 'body2',
  subtitle,
  className,
  grid,
  gridItem,
  swiper,
  spaceBetween,
  customCta: CustomCta,
  sliderBelow = false,
  toEdge = false,
}) {
  // need to also add swiper option...

  return (
    <Section className={classNames(styles.sectionWithGrid, className)}>
      <Text
        hat={hat}
        hatAs={hatAs}
        title={title}
        titleAs={titleAs}
        subtitleAs={subtitleAs}
        subtitle={subtitle}
      />

      <div
        className={classNames(
          'grid-container',
          'full-width',
          styles.gridContainer,
          { [styles.toEdge]: toEdge }
        )}
      >
        {swiper ? (
          <Swiper
            slides={grid}
            component={gridItem}
            spaceBetween={spaceBetween}
            sliderBelow={sliderBelow}
            {...swiper}
          />
        ) : (
          <Grid grid={grid} gridItem={gridItem} />
        )}
      </div>

      {CustomCta && <CustomCta />}
    </Section>
  )
}

const Grid = ({ grid, gridItem: GridItem }) => (
  <ul className={classNames(styles.grid, 'grid')}>
    {grid.map((item, idx) => (
      <GridItem key={item.id} {...item} />
    ))}
  </ul>
)
